import React from "react";
import * as PropTypes from "prop-types";
import { dataPropType } from "../../propTypes";
import { withStyles } from "@material-ui/styles";
import Introduction from "./introduction/Introduction";
import Theme1 from "./theme1/Theme1";
import Theme2 from "./theme2/Theme2";
import Theme3 from "./theme3/Theme3";
import Theme4 from "./theme4/Theme4";
import Theme5 from "./theme5/Theme5";

const styles = {
  container: {
    padding: "0 4rem",
    maxWidth: "1280px",
    margin: "0 auto"
  }
};

const Themes = props => (
  <div className={props.classes.container}>
    <Introduction
      onOpenDataAnnex={props.onOpenDataAnnex}
      onOpenCountryExplorer={props.onOpenCountryExplorer}
    />

    <Theme1
      database={props.data && props.data.databases.core}
      data={props.data && props.data.widgetData.theme1}
      onWidgetChange={props.onWidgetChange}
      onDownloadCsv={props.onDownloadCsv}
    />

    <Theme2
      database={props.data && props.data.databases.core}
      data={props.data && props.data.widgetData.theme2}
      onWidgetChange={props.onWidgetChange}
      onDownloadCsv={props.onDownloadCsv}
    />

    <Theme3
      database={props.data && props.data.databases.core}
      data={props.data && props.data.widgetData.theme3}
      onWidgetChange={props.onWidgetChange}
      onDownloadCsv={props.onDownloadCsv}
    />

    <Theme4
      database={props.data && props.data.databases.core}
      data={props.data && props.data.widgetData.theme4}
      onWidgetChange={props.onWidgetChange}
      onDownloadCsv={props.onDownloadCsv}
    />

    <Theme5
      database={props.data && props.data.databases.core}
      data={props.data && props.data.widgetData.theme5}
      onWidgetChange={props.onWidgetChange}
      onDownloadCsv={props.onDownloadCsv}
    />
  </div>
);

Themes.propTypes = {
  data: dataPropType,
  onOpenCountryExplorer: PropTypes.func.isRequired,
  onOpenDataAnnex: PropTypes.func.isRequired,
  onWidgetChange: PropTypes.func.isRequired,
  onDownloadCsv: PropTypes.func.isRequired
};

export default withStyles(styles)(Themes);
